function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Space, Select, Form, Drawer, Descriptions, Breadcrumb, Modal, DatePicker, Tag, Input, notification } from 'antd';
import { Table } from 'react-bootstrap';
import { ListUl, Search as SearchIcon, CalendarCheckFill, GraphUpArrow, HourglassSplit, ArrowClockwise } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import NewConsultation from "../components/forms/NewConsultation";
import PatientView from "../components/PatientView";
import NewAppointment from "../components/forms/NewAppointment";
import Appointment from "../components/Appointment";
import PatientPage from "./PatientPage";
import Moment from 'react-moment';
import SearchActivity from "../components/SearchActivity";
import RegisterPatient from "../components/forms/RegisterPatient";
import PatientFile from "../components/PatientFile";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;
var confirm = Modal.confirm;
var Consultations = function Consultations() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentDept = _useState2[0],
    setCurrentDept = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isDeptDataLoading = _useState4[0],
    setIsDeptDataLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    queueData = _useState6[0],
    setQueueData = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentQueueItem = _useState8[0],
    setCurrentQueueItem = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isConsultationDrawerVisible = _useState0[0],
    setIsConsultationDrawerVisible = _useState0[1];
  var _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    searchId = _useState10[0],
    setSearchId = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isPatientModalOpen = _useState12[0],
    setIsPatientModalOpen = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    dataChanged = _useState14[0],
    setDataChanged = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showRenewForm = _useState16[0],
    setShowRenewForm = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    patient = _useState18[0],
    setPatient = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    items = _useState20[0],
    setItems = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    rnProcessing = _useState22[0],
    setRnProcessing = _useState22[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    rnForm = _Form$useForm2[0];
  var onSearch = function onSearch(v) {
    setSearchId('');
    if (v.length > 0) {
      setSearchId(v);
      //setIsPatientModalOpen(true); 
    }
  };
  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getbydepcode/con/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCurrentDept(response.data.department);
        setQueueData([]);
        axios.get(Common.baseApiUrl + "getdailyqueue/" + response.data.department.id.toString()).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
        })["catch"](function (error) {
          message.error({
            content: error.toString(),
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getservicetree").then(function (response) {
      if (response.data.status == 200) {
        setItems([]);
        var lastItem = 0;
        response.data.services.forEach(function (d) {
          if (d.dcode == 'CON') {
            d.medical_items.forEach(function (e) {
              setItems(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  value: e.id,
                  label: e.label
                }]);
              });
              lastItem = e.id;
            });
          }
        });
        if (lastItem != 0) {
          rnForm.setFieldsValue({
            item: lastItem
          });
        }
      }
    })["catch"](function (error) {});
    setInterval(function () {
      setDataChanged(true);
    }, 120000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx(Breadcrumb, {
            items: [{
              title: 'Traitement'
            }, {
              title: "Consultation"
            }]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(ListUl, {
                  size: 35
                }), " File d'attente"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("ul", {
                            style: {
                              listStyleType: 'none'
                            },
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("li", {
                                children: /*#__PURE__*/_jsx(Tag, {
                                  color: "#f50",
                                  children: e.medical_item.label + "(" + e.medical_item.department.label + ")"
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: null,
                            href: "/#/home/patient/" + q.customer.idnumber,
                            size: "small",
                            children: /*#__PURE__*/_jsx("b", {
                              children: "CONSULTER"
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(HourglassSplit, {
                  size: 35
                }), " Historique"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 1;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("ul", {
                            style: {
                              listStyleType: 'none'
                            },
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("li", {
                                children: /*#__PURE__*/_jsx(Tag, {
                                  color: "#f50",
                                  children: e.medical_item.label + "(" + e.medical_item.department.label + ")"
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: null,
                            href: "/#/home/patient/" + q.customer.idnumber,
                            size: "small",
                            children: /*#__PURE__*/_jsx("b", {
                              children: "CONSULTER"
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 2), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(SearchIcon, {
                  size: 30
                })
              }),
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 4,
                  children: /*#__PURE__*/_jsxs("div", {
                    style: {
                      padding: "12px",
                      background: "#FFF",
                      borderRadius: "7px"
                    },
                    children: [/*#__PURE__*/_jsx("h6", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "NOUVEAU PATIENT"
                      })
                    }), /*#__PURE__*/_jsx(RegisterPatient, {
                      handler: function handler() {
                        setDataChanged(true);
                      }
                    })]
                  })
                }), /*#__PURE__*/_jsxs(Col, {
                  lg: 8,
                  md: 8,
                  children: [/*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 8,
                      md: 8,
                      children: /*#__PURE__*/_jsx(Search, {
                        placeholder: "Entrez ID ou Telephone",
                        size: "large",
                        onSearch: onSearch,
                        enterButton: true,
                        style: {
                          width: '100%',
                          marginBottom: '20px'
                        }
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      children: /*#__PURE__*/_jsx(Button, {
                        disabled: patient == null,
                        size: "large",
                        type: "primary",
                        onClick: function onClick() {
                          setShowRenewForm(true);
                        },
                        children: /*#__PURE__*/_jsx(ArrowClockwise, {
                          size: 18
                        })
                      })
                    })]
                  }), searchId.length > 0 && /*#__PURE__*/_jsx(PatientFile, {
                    setCheckPatient: setPatient,
                    patientId: searchId
                  })]
                })]
              })
            }, 3), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(CalendarCheckFill, {
                  size: 35
                }), " Rendez-vous"]
              }),
              children: /*#__PURE__*/_jsx(Appointment, {})
            }, 4), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GraphUpArrow, {
                  size: 35
                }), " Activit\xE9s"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                style: {
                  minHeight: '300px'
                },
                children: currentDept && /*#__PURE__*/_jsx(SearchActivity, {
                  dcode: currentDept.dcode
                })
              })
            }, 5)]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isConsultationDrawerVisible,
      title: "Nouvelle consultation",
      width: 370,
      onClose: function onClose() {
        setIsConsultationDrawerVisible(false);
      },
      closable: true,
      children: currentQueueItem != null && /*#__PURE__*/_jsx(NewConsultation, {
        handler: function handler() {
          setDataChanged(true);
        },
        queueId: currentQueueItem.id,
        queueData: queueData,
        patient: currentQueueItem.customer
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: "Infos patient",
      destroyOnClose: true,
      footer: null,
      visible: isPatientModalOpen,
      onCancel: function onCancel() {
        setIsPatientModalOpen(false);
      },
      children: /*#__PURE__*/_jsx(PatientView, {
        pid: searchId
      })
    }), patient && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "METTRE LE PATIENT DANS LA FILE"
        }),
        open: showRenewForm,
        footer: null,
        width: "450px",
        onCancel: function onCancel() {
          setShowRenewForm(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsxs(Form, {
          layout: "vertical",
          form: rnForm,
          onFinish: function onFinish(values) {
            setRnProcessing(true);
            axios.post(Common.baseApiUrl + "setcustomerforcheck", {
              customer_id: patient.id,
              item: values.item,
              user_id: Common.currentUser.id
            }).then(function (response) {
              if (response.data.status == 200) {
                setDataChanged(true);
                setShowRenewForm(false);
                var tmp = searchId;
                setSearchId("temp");
                setSearchId(tmp);
                notification.success({
                  message: "Ok!",
                  description: response.data.message
                });
              } else {
                notification.error({
                  message: "Erreur!",
                  description: response.data.message
                });
              }
            })["catch"](function (error) {
              notification.error({
                message: "Erreur!",
                description: "Une erreur est survenue " + error.toString()
              });
            })["finally"](function () {
              setRnProcessing(false);
            });
          },
          children: [/*#__PURE__*/_jsx(Form.Item, {
            name: "item",
            rules: [{
              required: true,
              message: "Veuillez choisir un article"
            }],
            children: /*#__PURE__*/_jsx(Select, {
              options: items
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            children: /*#__PURE__*/_jsx(Button, {
              loading: rnProcessing,
              type: "primary",
              htmlType: "submit",
              children: /*#__PURE__*/_jsx("b", {
                children: "CONFIRMER"
              })
            })
          })]
        })
      })
    })]
  });
};
export default Consultations;